import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { MuseumCollection } from 'src/app/museum-collections/models';
import { CollectionCardComponent } from 'src/app/museum-collections/components';

import { LinkComponent } from '@teamfoster/sdk/button';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
    selector: 'app-content-block-collections',
    imports: [ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe, CollectionCardComponent, LinkComponent, IconComponent],
    templateUrl: './content-block-collections.component.html',
    styleUrl: './content-block-collections.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockCollectionsComponent extends ContentBlockBaseComponent {}
